import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AccountTypeIdEnum } from '../../../models/enum/shared/account-type-id.enum';

export function atLeastOneAccountSelectedValidator(
  selectedAccountTypeId: () => AccountTypeIdEnum | null | undefined
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const accounts = (control as FormArray).controls;
    const atLeastOneSelected = accounts.some(
      account => account.get('selected')?.value && account.get('accountTypeId')?.value === selectedAccountTypeId()
    );
    return atLeastOneSelected ? null : { noAccountSelected: true };
  };
}
